import React from "react";
import { useContext, useState, useEffect } from "react";
import FiltersDashboard from "../Filters/FiltersDashboard";
import GlobalChartMiniCard from "../cards/miniCards/GlobalChartMiniCard";
import GlobalAudienciaMiniCard from "../cards/miniCards/GlobalAudienciaMiniCard";
import SectionCard from "../cards/informationCards/SectionCard";
import GlobalSegmentacionNegativeChart from "../charts/barWithNegatives/GlobalSegmentacionNegativeChart";
import GlobalLineDashedChart from "../charts/lineChart/GlobalLineDashedChart";
import { FilterContext } from "../../context/FilterContext";
import {
  fetchGlobalCardData,
  fetchGlobalSegmentacionData,
  fetchGlobalWatchersTimeData,
} from "../../services/cardDataFunctions";

import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConversionIcon from "../../assets/conversion.svg";
import AtencionIcon from "../../assets/TiempoAtencionIcon.svg";
import EstadiaIcon from "../../assets/EstadiaIcon.svg";
// import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
// import HourglassBottomOutlinedIcon from "@mui/icons-material/HourglassBottomOutlined";
import HelpIcon from "@mui/icons-material/Help";

const Dashboard = () => {
  const { filtersObj } = useContext(FilterContext);
  // estados para los objetos de las camaras}
  const [globalCardsObj, setGlobalCardsObj] = useState({});
  const [leftCameraObj, setLeftCameraObj] = useState({});
  const [centerCameraObj, setCenterCameraObj] = useState({});
  const [rightCameraObj, setRightCameraObj] = useState({});
  const [segmentationGlobalData, setSegmentationGlobalData] = useState({});
  const [watchersTimeGlobalData, setWatchersTimeGlobalData] = useState({});
  const [globalSegmentacionLoader, setGlobalSegmentacionLoader] =
    useState(false);
  const [globalWatchersTimeLoader, setGlobalWatchersTimeLoader] =
    useState(false);
  const [globalCardsLoader, setGlobalCardsLoader] = useState(false);

  // estado para el boton de ayuda
  const [helpButton, setHelpButton] = useState(false);

  // useEffect para crear el objeto de cada camara
  useEffect(() => {
    if (filtersObj.cameras) {
      const createCameraObject = (position) => {
        const camera = filtersObj.cameras.find(
          (camera) => camera.position === position
        );
        return camera
          ? {
              store_id: filtersObj.store_id,
              camera_id: camera.id,
              camera_name: camera.name,
              age_ranges: filtersObj.age_ranges || [],
              age_range_name: filtersObj.age_range_name,
              start_date: filtersObj.start_date,
              end_date: filtersObj.end_date,
            }
          : {};
      };

      setLeftCameraObj(createCameraObject("left"));
      setCenterCameraObj(createCameraObject("center"));
      setRightCameraObj(createCameraObject("right"));
    }
  }, [filtersObj]);

  // useEffect para obtener los datos de las tarjetas globales
  useEffect(() => {
    const controller = new AbortController();
    const loadGlobalCards = async () => {
      if (
        !filtersObj.store_id ||
        filtersObj.age_ranges.length === 0 ||
        !filtersObj.start_date ||
        !filtersObj.end_date
      )
        return;
      setGlobalCardsLoader(true);
      try {
        fetchGlobalCardData(filtersObj, controller.signal).then((data) => {
          setGlobalCardsObj(data);
        });
      } catch (error) {
        console.error(
          "Error al obtener los datos de las tarjetas globales",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching orders and resolutions stats", error);
        }
      } finally {
        setGlobalCardsLoader(false);
      }
    };
    loadGlobalCards();
    return () => controller.abort();
  }, [filtersObj]);

  // useEffect para obtener los datos de la grafica de segmentacion
  useEffect(() => {
    const controller = new AbortController();
    const loadGlobalSegmentacion = async () => {
      if (
        !filtersObj.store_id ||
        filtersObj.age_ranges.length === 0 ||
        !filtersObj.start_date ||
        !filtersObj.end_date
      )
        return;
      setGlobalSegmentacionLoader(true);
      try {
        fetchGlobalSegmentacionData(filtersObj, controller.signal).then(
          (data) => {
            setSegmentationGlobalData(data);
          }
        );
      } catch (error) {
        console.error(
          "Error al obtener los datos de las tarjetas globales",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching orders and resolutions stats", error);
        }
      } finally {
        setGlobalSegmentacionLoader(false);
      }
    };
    loadGlobalSegmentacion();
    return () => controller.abort();
  }, [filtersObj]);

  // useEffect para obtener los datos de la grafica de watchers vs tiempo
  useEffect(() => {
    const controller = new AbortController();
    const loadGlobalWatchersTime = async () => {
      if (
        !filtersObj.store_id ||
        filtersObj.age_ranges.length === 0 ||
        !filtersObj.start_date ||
        !filtersObj.end_date
      )
        return;
      setGlobalWatchersTimeLoader(true);
      try {
        fetchGlobalWatchersTimeData(filtersObj, controller.signal).then(
          (data) => {
            setWatchersTimeGlobalData(data);
          }
        );
      } catch (error) {
        console.error(
          "Error al obtener los datos de las tarjetas globales",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching orders and resolutions stats", error);
        }
      } finally {
        setGlobalWatchersTimeLoader(false);
      }
    };
    loadGlobalWatchersTime();
    return () => controller.abort();
  }, [filtersObj]);

  return (
    <div className="flex flex-col w-full h-full gap-5 px-4 pb-6 bg-transparent">
      <div>
        <FiltersDashboard />
      </div>
      {/* información general */}
      <div className="w-full h-full overflow-auto shadow-2xl rounded-2xl bg-white/45 scrollbar-thin scrollbar-thumb-transparent scrollbar-track-transparent">
        {/* minicards */}
        <div className="flex flex-col p-4 rounded-t-2xl bg-[#0369A1] shadow">
          <div className="flex justify-start gap-2">
            <HelpIcon
              sx={{
                color: "#FFF",
                cursor: "pointer",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.1)" },
                "&:active": { transform: "scale(0.9)" },
              }}
              onClick={() => {
                setHelpButton(!helpButton);
                setTimeout(() => setHelpButton(false), 20000);
              }}
            />
            <h2 className="text-lg text-white font-Roboto font-bold">
              Información general sucursal:
            </h2>
            <h3 className="text-lg text-white font-Roboto ml-2">
              {filtersObj.store_name}
            </h3>
          </div>
          {/* Cards globales  */}
          <div className="flex gap-4 p-2">
            <div className="w-full h-full">
              <div className="grid md:grid-cols-10 xl:grid-cols-11 gap-4 h-full">
                <div className="md:col-start-1 md:col-end-3 2xl:col-start-1 2xl:col-end-3 row-start-1 row-end-2 flex justify-around">
                  {/* Audiencia Global */}
                  <GlobalAudienciaMiniCard
                    data={globalCardsObj.audiencia_total || 0}
                    globalCardsLoader={globalCardsLoader}
                    helperText={
                      helpButton ? "Personas captadas por la cámara" : ""
                    }
                  />
                </div>
                <div className="md:col-start-3 md:col-end-5 xl:col-start-3 xl:col-end-5 row-start-1 row-end-2">
                  {/* Observadores Global */}
                  <GlobalChartMiniCard
                    title={"Observadores:"}
                    suffix={""}
                    data={{
                      man: globalCardsObj.observadores_man || 0,
                      woman: globalCardsObj.observadores_women || 0,
                      total: globalCardsObj.observadores_total || 0,
                    }}
                    globalCardsLoader={globalCardsLoader}
                    Icon={VisibilityIcon}
                    helperText={
                      helpButton ? "Personas que observaron la pantalla" : ""
                    }
                  />
                </div>
                <div className="md:col-start-5 md:col-end-7 xl:col-start-5 xl:col-end-7 row-start-1 row-end-2">
                  {/* Conversión Global */}
                  <GlobalChartMiniCard
                    title={"Conversión:"}
                    suffix={"%"}
                    data={{
                      man: globalCardsObj.conversion_rate_man || 0,
                      woman: globalCardsObj.conversion_rate_woman || 0,
                      total: globalCardsObj.conversion_rate_total || 0,
                    }}
                    globalCardsLoader={globalCardsLoader}
                    Icon={ConversionIcon}
                    helperText={
                      helpButton
                        ? "% de personas de audiencia que observaron"
                        : ""
                    }
                  />
                </div>
                <div className="md:col-start-7 md:col-end-9 md:row-start-1 md:row-end-2 xl:col-start-1 xl:col-end-4 xl:row-start-2 xl:row-end-3">
                  {/* Atención Global */}
                  <GlobalChartMiniCard
                    title={"Atención:"}
                    suffix={" s."}
                    data={{
                      man: globalCardsObj.observadores_man_attention_time || 0,
                      woman:
                        globalCardsObj.observadores_woman_attention_time || 0,
                      total:
                        globalCardsObj.observadores_total_attention_time || 0,
                    }}
                    globalCardsLoader={globalCardsLoader}
                    Icon={AtencionIcon}
                    helperText={
                      helpButton ? "Tiempo que observaron la pantalla" : ""
                    }
                  />
                </div>
                <div className="md:col-start-9 md:col-end-11 md:row-start-1 md:row-end-2 xl:col-start-4 xl:col-end-7 xl:row-start-2 xl:row-end-3">
                  {/* Estadía Global */}
                  <GlobalChartMiniCard
                    title={"Estadía:"}
                    suffix={" s."}
                    data={{
                      man: globalCardsObj.observadores_man_dwell_time || 0,
                      woman: globalCardsObj.observadores_woman_dwell_time || 0,
                      total: globalCardsObj.observadores_total_dwell_time || 0,
                    }}
                    globalCardsLoader={globalCardsLoader}
                    Icon={EstadiaIcon}
                    helperText={
                      helpButton
                        ? "Tiempo de la audiencia captada por la cámara"
                        : ""
                    }
                  />
                </div>
                <div className="md:col-start-1 md:col-end-6 md:row-start-2 md:row-end-3 xl:col-start-7 xl:col-end-12 xl:row-start-1 xl:row-end-2">
                  {/* Segmentación Global */}
                  <div className="">
                    <div className="px-0 pt-4">
                      {globalSegmentacionLoader ? (
                        <CircularProgress color="secondary" />
                      ) : segmentationGlobalData ? (
                        <GlobalSegmentacionNegativeChart
                          segmentationGlobalData={segmentationGlobalData}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="md:col-start-6 md:col-end-11 md:row-start-2 md:row-end-3 xl:col-start-7 xl:col-end-12 xl:row-start-2 xl:row-end-3">
                  {/* Observadores vs Tiempo */}
                  <div className="">
                    <div className="px-0 pt-4">
                      {globalWatchersTimeLoader ? (
                        <CircularProgress color="secondary" />
                      ) : watchersTimeGlobalData ? (
                        <GlobalLineDashedChart
                          watchersTimeGlobalData={watchersTimeGlobalData}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* información minicards segunda version y graficas */}
        <div className="p-4 bg-[#BAE6FD]">
          {/* graficas */}
          <div className="grid lg:grid-cols-1 xl:grid-cols-3 gap-4 mt-4 ">
            <div>
              <SectionCard cameraObj={leftCameraObj} position={"left"} />
            </div>
            <div>
              <SectionCard cameraObj={centerCameraObj} position={"center"} />
            </div>
            <div>
              <SectionCard cameraObj={rightCameraObj} position={"right"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
